export default {
  title: 'Verzendgegevens',
  buttons: {
    save: 'Opslaan',
  },
};
